export default __webpack_public_path__ + "static/media/ibc.96d8296d.webp";